export const getDisplayContentLanguagesService = () => {
  // Need to implement api call to get the laguage
  const lang = [
    {
      languageId: 1,
      title: 'English',
      code: 'en'
    },
    {
      languageId: 2,
      title: 'Spanish (Mexico)',
      code: 'es_MX'
    }
  ];
  return new Promise((resolve) => resolve(lang));
};
